module.exports = __webpack_public_path__ + "img/calculator.e42b1270.svg";